import { useState, useEffect } from "react";
import { FormControl, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const months = [
  { value: "01", label: "January" },
  { value: "02", label: "February" },
  { value: "03", label: "March" },
  { value: "04", label: "April" },
  { value: "05", label: "May" },
  { value: "06", label: "June" },
  { value: "07", label: "July" },
  { value: "08", label: "August" },
  { value: "09", label: "September" },
  { value: "10", label: "October" },
  { value: "11", label: "November" },
  { value: "12", label: "December" },
];

const getDaysInMonth = (month: string, year: string) => {
  if (!month || !year) return 31;
  return new Date(parseInt(year), parseInt(month), 0).getDate();
};

const currentYear = new Date().getFullYear();
const years = Array.from({ length: 100 }, (_, i) => (currentYear - 10 - i).toString());

interface DateOfBirthFieldProps {
  value: string;
  onChange: (value: string) => void;
}

const DateOfBirthField = ({ value, onChange }: DateOfBirthFieldProps) => {
  const [month, setMonth] = useState("");
  const [day, setDay] = useState("");
  const [year, setYear] = useState("");

  // Parse existing value on mount
  useEffect(() => {
    if (value) {
      const parts = value.split("-");
      if (parts.length === 3) {
        setYear(parts[0]);
        setMonth(parts[1]);
        setDay(parts[2]);
      }
    }
  }, []);

  const daysCount = getDaysInMonth(month, year);
  const days = Array.from({ length: daysCount }, (_, i) => (i + 1).toString().padStart(2, "0"));

  const updateDateOfBirth = (m: string, d: string, y: string) => {
    if (m && d && y) {
      onChange(`${y}-${m}-${d}`);
    }
  };

  return (
    <FormItem>
      <FormLabel>Date of Birth <span className="text-destructive">*</span></FormLabel>
      <div className="grid grid-cols-3 gap-2">
        <Select value={month} onValueChange={(v) => { setMonth(v); updateDateOfBirth(v, day, year); }}>
          <FormControl>
            <SelectTrigger>
              <SelectValue placeholder="Month" />
            </SelectTrigger>
          </FormControl>
          <SelectContent>
            {months.map((m) => (
              <SelectItem key={m.value} value={m.value}>{m.label}</SelectItem>
            ))}
          </SelectContent>
        </Select>
        <Select value={day} onValueChange={(v) => { setDay(v); updateDateOfBirth(month, v, year); }}>
          <FormControl>
            <SelectTrigger>
              <SelectValue placeholder="Day" />
            </SelectTrigger>
          </FormControl>
          <SelectContent>
            {days.map((d) => (
              <SelectItem key={d} value={d}>{parseInt(d)}</SelectItem>
            ))}
          </SelectContent>
        </Select>
        <Select value={year} onValueChange={(v) => { setYear(v); updateDateOfBirth(month, day, v); }}>
          <FormControl>
            <SelectTrigger>
              <SelectValue placeholder="Year" />
            </SelectTrigger>
          </FormControl>
          <SelectContent>
            {years.map((y) => (
              <SelectItem key={y} value={y}>{y}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <FormMessage />
    </FormItem>
  );
};

export default DateOfBirthField;
